// import store from '@/store'
import { getData } from '@core/utils/http/general'

//* Make http request to get info by course id
export const periodsFromPlan = plan => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 21,
    plan,
  }

  getData(paramsRequest, 'wspublico')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data.periodos)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Get period's scheadule
export const periodScheadule = periodo => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 22,
    periodo,
  }

  getData(paramsRequest, 'wspublico')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
